module.exports = __webpack_public_path__ + "img/1.92318fd2.png";